import React, { useEffect } from 'react'
import ENDPOINT from '../../data/ENDPOINT';
import SecurityHeaders from '../../data/SecurityHeaders';
import axios from 'axios';
import LanguageIcon from '@mui/icons-material/Language';
import LocationSearchingIcon from '@mui/icons-material/LocationSearching';
import FolderCopyIcon from '@mui/icons-material/FolderCopy';
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom/cjs/react-router-dom';
const ToolDetails = () => {
    const params = useParams()
useEffect(()=>{
window.scrollTo(0,0)
},[])
    const [toolDetailsData, setToolDetailsData] = React.useState([]);
    const toolDetails = async () => {
        const data = new FormData();
        data.append('id', params.id);

        const toolDetails = await axios.post(ENDPOINT + 'get-tool-details.php', data, SecurityHeaders);
        if (toolDetails) {
            if (toolDetails.data.status === "success") {
                setToolDetailsData(toolDetails.data.data);
                console.log(toolDetailsData);
            }
        } else {
            console.error('Failed to fetch hacking tools');
        }
    }

    useEffect(() => {
        toolDetails();
    }, []);
    return (
        <div>
            <>
                <div className='container' >
                    {
                        toolDetailsData ? <div className='row justify-content-between my-5'>
                            <div className='col-lg-3  col-12'>
                                
                                <img className='w-100 rounded' src={toolDetailsData.image} alt="" />
                                <h3 className='ms-2 mt-2 mb-0'>{toolDetailsData.title}</h3>
                                <div className=' d-flex  align-items-center '>
                                    <i className='bg-light p-1 text-danger rounded '><strong>version:</strong> {toolDetailsData.version}</i>
                                    <div className='ms-2'>
                                        <i className='bg-light p-1 text-danger rounded'><strong>Installed size:</strong> {toolDetailsData.size} MB</i>
                                    </div>

                                </div>
                                <hr />
                                <div className='d-flex'>
                                    <LanguageIcon className="text-primary" />

                                    <p className='ms-1'>Responder Homepage</p>


                                </div>
                                <div className='d-flex mt-2'>
                                    <LocationSearchingIcon className="text-success" />
                                    <p className='ms-1'>Package Tracker</p>
                                </div>
                                <div className='d-flex mt-2'>
                                    <FolderCopyIcon className="text-warning" />
                                    <p className='ms-1'>Resource Code Repository</p>
                                </div>

                                <div className='d-flex mt-3 col-12' >
                                <a  className='border-0 rounded rounded-3  me-1 btn btn-primary col-6' target='_blank' href={toolDetailsData.tool_notes}  >    Read More   </a>  
                              <a className=' border-0 rounded rounded-3 p-2 btn btn-danger col-6' target='_blank' href={toolDetailsData.tool_video} >Watch Tutorial</a> 
                              
                              
                                </div>

                            </div>
                            <div className='col-lg-8 col-12'>
                                <h1>Description:</h1>
                                <hr />


                                <p className='fs-5' >{toolDetailsData.description}</p>


                            </div>
                        </div>
                            : <h1>Loading...</h1>
                    }

                </div>
            </>


        </div>
    )
}

export default ToolDetails
